import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
/** @jsx jsx */

import { jsx, css } from '@emotion/react';
import { N30 } from '@atlaskit/theme/colors';
var ExtensionFrame = function ExtensionFrame(props) {
  var containerCSS = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    border: 1px solid ", ";\n    min-height: 100px;\n  "])), "var(--ds-border, ".concat(N30, ")"));
  return jsx("div", {
    css: containerCSS,
    className: "extension-frame",
    "data-extension-frame": "true",
    style: {
      flexBasis: "100%"
    }
  }, props.children);
};
export default ExtensionFrame;